/**
 * 退出登录时清理用户缓存。
 * 保留 deviceId（设备标识需跨账号复用）。
 */
const LOGIN_CACHE_KEYS = [
  'token',
  'vuex',
  'userName',
  'username',
  'headImg',
  'headimg_url',
  'phone',
  'hpStatus',
  'h5_openId',
];

const clearLoginCache = () => {
  LOGIN_CACHE_KEYS.forEach((key) => {
    window.localStorage.removeItem(key);
  });
};

export default clearLoginCache;
